import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import {
  FormElementInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'

export const useUpdateFormElementProp = <
  Element extends FormElementInterface,
  Key extends keyof Element,
>(
  formEntity: FormInterface,
  updatedElement: Element,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (prop: Key) => (value: Element[Key]) => {
    updateEntity({
      ...formEntity,
      elements: formEntity.elements.map(element =>
        element.id === updatedElement.id
          ? { ...element, [prop]: value }
          : element,
      ),
    })
  }
}

export const useUpdateFormElementProps = <Element extends FormElementInterface>(
  formEntity: FormInterface,
  updatedElement: Element,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (updatedProps: Partial<Element>) => {
    updateEntity({
      ...formEntity,
      elements: formEntity.elements.map(element =>
        element.id === updatedElement.id
          ? { ...element, ...updatedProps }
          : element,
      ),
    })
  }
}
